import React from "react"
import Translation from "../../services/translation.service"
import StepPassBlue from "../../assets/img/StepPass.svg"
import StepFailedRed from "../../assets/img/StepFailed.svg"

const StepperStep = ({
title,
desc,
step,
status,
activeIcon,
nonActive
}) => {

  const isActive = status === "inProgress" || status === "isDone" || status === "isFailed"
    return (<div className="stepper-step-container">
      <div className="content-container">
      <div className="title-container">
          <img src={isActive ? activeIcon : nonActive} alt="call"/>
          <p className={`title ${isActive ? "" : "inactive"}`}>
            {Translation.keys["stf-step"] || "Step"} {step}: {title}</p>
        </div>
        <p className={`desc ${isActive ? "": "inactive"}`}>{desc}</p>
      </div>
      {status === "isDone" ? <img className="check" src={StepPassBlue} alt="tick" /> : ""}
      {status === "isFailed" ? <img className="check" src={StepFailedRed} alt="tick" /> : ""}
    </div>)
}

export default StepperStep